import { Product } from '@interfaces/models/orderSaleProduct';
import { useTranslation } from 'next-i18next';
import Icon from '@components/atoms/icon/icon';
import { onImageError, productImage } from '../helper';
import styles from '../product-timeline.module.scss';

const ProductView: React.FC<{
  product: Product;
}> = ({ product }) => {
  const { t } = useTranslation('orders-sales');
  const { productName, brandName, imageUrl, ezlink, isDirectShipping, productId, externalRef } = product;
  return (
    <div className={styles.ordersSales__mainRight__product}>
      <div className={styles.ordersSales__mainRight__product__left}>
        <a
          href={ezlink}
          rel={'noreferrer'}
          target={'_blank'}
        >
          <img
            className={styles.ordersSales__mainRight__product__left__image}
            src={productImage(imageUrl)}
            alt={productName}
            onError={onImageError}
          />
        </a>
      </div>
      <div className={styles.ordersSales__mainRight__product__right}>
        <div className={styles.ordersSales__mainRight__product__right__name}>{brandName}</div>
        <div className={styles.ordersSales__mainRight__product__right__type}>{productName}</div>
        <div className={styles.ordersSales__mainRight__product__right__price}>
          {t('MY_ACCOUNT.ORDERS_SALES.LIST.REF')}. {productId}
        </div>
        {externalRef && <div className={styles.ordersSales__mainRight__product__right__price}>{externalRef}</div>}
        {isDirectShipping && (
          <div className={styles.ordersSales__mainRight__product__right__directShipping}>
            <Icon
              className={styles.ordersSales__mainRight__product__right__directShipping__icon}
              name="handshake"
              ariaHidden
            />
            <div className={styles.ordersSales__mainRight__product__right__directShipping__text}>
              {t('MY_ACCOUNT.ORDERS_SALES.DIRECT_SHIPPING')}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductView;
